import React from 'react';
import { CreditCardIcon, FileCheck2Icon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { FadeIn } from './FadeIn';
export function OfferSection() {
  return <section id="adquirir" className="px-5 py-14 md:px-8 md:py-20" data-id="element-113">
      <div className="mx-auto max-w-3xl" data-id="element-114">
        <FadeIn className="text-center" data-id="element-115">
          <p className="text-sm font-bold uppercase tracking-[0.18em] text-accent" data-id="element-116">
            Acceso completo
          </p>
          <h2 className="mt-2 font-display text-3xl font-bold text-white md:text-4xl" data-id="element-117">
            Todo esto está incluido hoy
          </h2>
        </FadeIn>

        <FadeIn className="mt-8 border border-accent/50 bg-charcoal p-6 shadow-[0_16px_40px_rgba(0,0,0,0.25)] md:p-8" data-id="element-118">
          <div className="flex flex-col justify-between gap-6 border-b border-white/10 pb-6 sm:flex-row sm:items-end" data-id="element-119">
            <div data-id="element-120">
              <div className="flex items-center gap-2 text-accent" data-id="element-121">
                <FileCheck2Icon size={20} aria-hidden="true" data-id="element-122" />
                <p className="text-xs font-bold uppercase tracking-[0.18em]" data-id="element-123">
                  Conversion Elite™
                </p>
              </div>
              <h3 className="mt-3 font-display text-2xl font-bold text-white md:text-3xl" data-id="element-124">
                Tratado Práctico de Modernización Laboral 2026
              </h3>
            </div>
            <div className="shrink-0 text-left sm:text-right" data-id="element-125">
              <p className="text-xs uppercase tracking-wider text-stone-500" data-id="element-126">
                Hoy
              </p>
              <p className="mt-1 text-4xl font-extrabold text-accent" data-id="element-127">
                AR$ 27.990
              </p>
            </div>
          </div>

          <motion.a href="https://tratado-practico-de-modernizacion-laboral-2026.impultienda.ar/checkout" whileHover={{
          y: -2
        }} whileTap={{
          scale: 0.98
        }} className="flex w-full items-center justify-center gap-2 bg-accent px-6 py-4 text-sm font-extrabold uppercase tracking-wide text-ink shadow-[0_10px_30px_rgba(183,142,69,0.2)] transition-colors hover:bg-[#d2ae6e] focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2 focus:ring-offset-charcoal md:text-base" data-id="element-128">
            Quiero mi tratado ahora
            <CreditCardIcon size={19} aria-hidden="true" data-id="element-129" />
          </motion.a>
          <p className="mt-4 text-center text-xs italic leading-relaxed text-stone-500" data-id="element-130">
            La opción elegida por abogados que buscan optimizar su práctica y
            ahorrar horas de trabajo en cada expediente.
          </p>
        </FadeIn>

        <div className="mt-5 grid grid-cols-2 gap-px border border-white/10 bg-white/10 md:grid-cols-4" data-id="element-131">
          {[[LockKeyholeIcon, 'Pago seguro'], [ZapIcon, 'Acceso inmediato'], [ShieldCheckIcon, 'Garantía 7 días'], [FileCheck2Icon, 'Material digital']].map(([Icon, label]) => {
          const TrustIcon = Icon as typeof LockKeyholeIcon;
          return <div key={label as string} className="flex flex-col items-center gap-2 bg-ink px-3 py-4 text-center" data-id="element-132">
                <TrustIcon size={17} className="text-accent" aria-hidden="true" data-id="element-133" />
                <span className="text-xs font-semibold text-stone-300" data-id="element-134">
                  {label as string}
                </span>
              </div>;
        })}
        </div>

        <div className="mt-9 grid gap-4 md:grid-cols-3" data-id="element-135">
          <article className="border border-white/10 bg-charcoal p-5" data-id="element-136">
            <h3 className="font-display text-xl font-bold text-white" data-id="element-137">
              ¿Y si recién comienzo a ejercer?
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-stone-400" data-id="element-138">
              Contarás con modelos, contratos, escritos y fundamentos para
              trabajar con mayor seguridad desde tus primeros casos.
            </p>
          </article>
          <article className="border border-white/10 bg-charcoal p-5" data-id="element-139">
            <h3 className="font-display text-xl font-bold text-white" data-id="element-140">
              ¿Y si ya tengo experiencia?
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-stone-400" data-id="element-141">
              Reducirás el tiempo de redacción y organización con una
              metodología creada para la práctica profesional diaria.
            </p>
          </article>
          <article className="border border-white/10 bg-charcoal p-5" data-id="element-142">
            <h3 className="font-display text-xl font-bold text-white" data-id="element-143">
              ¿Y si no cumple mis expectativas?
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-stone-400" data-id="element-144">
              Disponés de garantía total de 7 días y el reintegro del 100% del
              importe abonado.
            </p>
          </article>
        </div>
      </div>
    </section>;
}